// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"4cd522ca","652":"655e22fe","703":"4f42a720"}[chunkId] + ".chunk.js";
};